module.exports = __webpack_public_path__ + "static/media/gal0501.9e4858ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal05/gal0501.jpg
// module id = 377
// module chunks = 0